import { combineEpics } from 'redux-observable';
import { combineReducers } from 'redux';

import { oauthEpic, oauthStore } from '../reducers/oauth/duck';
import { userStore, userEpic } from '../reducers/user/duck';
import { registrationStore, registrationEpic } from '../reducers/registration/duck';
import { restorePasswordStore, restorePasswordEpic } from '../reducers/restore-password/duck';
import { resetPasswordStore, resetPasswordEpic } from '../reducers/reset-password/duck';
import { linkedinStore, linkedinEpic } from '../reducers/linkedin/duck';
import { createAppStore, createAppEpic } from '../reducers/create-app/duck';
import { campaignStore, campaignEpic } from '../reducers/create-campaign/duck';
import { mediaStore, mediaEpic } from '../reducers/media/duck';
import { paymentStore, paymentEpic } from '../reducers/payment/duck';
import { dashboardStore, dashboardEpic } from '../reducers/dashboard/duck';
import { alertStore } from '../reducers/alert-ui/duck';
import { createAdminsEpic, createAdminStore } from '../reducers/create-admin/duck';

export const rootEpic = combineEpics(
  oauthEpic,
  userEpic,
  registrationEpic,
  linkedinEpic,
  restorePasswordEpic,
  resetPasswordEpic,
  createAppEpic,
  campaignEpic,
  mediaEpic,
  paymentEpic,
  dashboardEpic,
  createAdminsEpic,
);

export const rootReducer = combineReducers({
  oauthStore,
  userStore,
  registrationStore,
  linkedinStore,
  restorePasswordStore,
  resetPasswordStore,
  createAppStore,
  campaignStore,
  mediaStore,
  paymentStore,
  dashboardStore,
  alertStore,
  createAdminStore,
});



// WEBPACK FOOTER //
// ./src/store/index.js